import { render, staticRenderFns } from "./VantDiscussRecallPop.vue?vue&type=template&id=675b79a5&"
import script from "./VantDiscussRecallPop.vue?vue&type=script&lang=js&"
export * from "./VantDiscussRecallPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports